import '@splidejs/splide/css/core'

import Splide from '@splidejs/splide'
import { BlogPostCarousel } from '@/components/templates/BlogPostCarousel'
import { FilteredList } from '@/components/FilteredList'
import { Sleep } from '@/utils/Sleep'
import { Events, EventType } from '@/utils/Events'
// import { AnimateSection } from '@/components/AnimateSection'

export class FilteredListBlogTypes extends FilteredList {
  async init() {
    super.init()

    this.featuredBlogposts = document.querySelectorAll('[data-featured-blogpost-id]')
    this.filterButtons = this.getAll('[data-filter-type]')
    this.content = this.get('.c-filtered-list-content')
    this.onFilterClick = this.onFilterClick.bind(this)
    this.onQueryFilters = this.onQueryFilters.bind(this)

    const urlParams = new URLSearchParams(location.search)
    const filters = urlParams.getAll('filter').filter((value) => value !== '')
    if (filters.length) this.onQueryFilters(filters)
    else this.renderItems()
  }

  initAnimation() {
    // this.add('[data-animate-section]', AnimateSection, this.el, 'AnimateSection', true)
  }

  initCarousels() {
    this.slideEls = this.getAll('.splide')
    this.slideInstances = []

    this.slideEls.forEach((slideEl) => {
      const slides = slideEl.querySelectorAll('.splide__slide')
      const showArrows = slides.length > 3
      const showArrowsMobile = slides.length > 1
      const slideInstance = new Splide(slideEl, {
        perPage: 3,
        perMove: 1,
        drag: showArrows,
        gap: '3.5rem',
        arrows: showArrows,
        breakpoints: {
          800: {
            perPage: 1,
            arrows: showArrowsMobile,
          },
        },
      })

      slideInstance.mount()

      this.slideInstances.push(slideInstance)
    })
  }

  destroyCarousels() {
    if (!this.slideInstances) return

    this.slideInstances.forEach((slideInstance) => slideInstance.destroy())
  }

  addEvents() {
    super.addEvents()
  }

  destroy() {
    super.destroy()
  }

  onQueryFilters(filters) {
    this.activeFilters = filters

    const allButton = this.get('[data-filter-type="all"]')
    if (allButton) allButton.classList.remove('is-active')

    this.filterButtons.forEach((button) => {
      if (this.activeFilters.includes(button.dataset.filterType)) button.classList.add('is-active')
      else button.classList.remove('is-active')
    })

    if (this.activeFilters.length === 0 && allButton) allButton.classList.add('is-active')

    this.renderItems(this.activeFilters)
  }

  onFilterClick(e) {
    super.onFilterClick(e)
  }

  async renderItems() {
    if (!this.content) return
    const height = this.content.offsetHeight
    this.content.style.height = `${height}px`

    try {
      // Fetch data
      this.data = this.data ?? (await this.fetchData(this.el.dataset.filteredList))
      this.types = this.types ?? (await this.fetchData(this.el.dataset.types))
      this.globals = this.globals ?? (await this.fetchData(this.el.dataset.translations))

      // Filter our featured blogposts
      const allBlogData = this.data.blog
      const featuredPostsIds = Array.from(this.featuredBlogposts).map((post) => Number(post.dataset.featuredBlogpostId))
      let blogData = allBlogData
      if (featuredPostsIds.length) blogData = blogData.filter((post) => !featuredPostsIds.includes(post.id))
      const filteredData = this.filterData(blogData)

      this.destroyCarousels()
      this.content.innerHTML = ''

      // Create elements
      this.types.types.forEach((type) => {
        let filderedByType = filteredData
          .filter((entry) => entry.type === type.id || entry.type === type.name)
          .map((item) => {
            const rawType = item.type
            const rawSubtype = item.subtype

            return {
              ...item,
              isEvent: rawType === 'event',
              type: rawType ? this.globals[`label${String(rawType).toLowerCase()}`] ?? rawType : rawType,
              subtype: rawSubtype ? this.globals[`label${String(rawSubtype).toLowerCase()}`] ?? rawSubtype : rawSubtype,
            }
          })

        // Keep type sections visible when all matching items are featured.
        if (!filderedByType.length && this.activeFilters.length === 0 && featuredPostsIds.length) {
          filderedByType = allBlogData
            .filter((entry) => featuredPostsIds.includes(entry.id))
            .filter((entry) => entry.type === type.id || entry.type === type.name)
            .map((item) => {
              const rawType = item.type
              const rawSubtype = item.subtype

              return {
                ...item,
                isEvent: rawType === 'event',
                type: rawType ? this.globals[`label${String(rawType).toLowerCase()}`] ?? rawType : rawType,
                subtype: rawSubtype ? this.globals[`label${String(rawSubtype).toLowerCase()}`] ?? rawSubtype : rawSubtype,
              }
            })
        }

        this.appendToContent(
          filderedByType.slice(0, 9),
          this.globals[`label${type.id.toLowerCase()}Title`] ?? 'Blogpost',
          type.url,
          this.globals
        )
      })

      await Sleep()

      this.initCarousels()
      this.initAnimation()
      Events.emit(EventType.FILTER_BLOG_INIT)
    } catch (error) {
      this.destroyCarousels()
      this.content.innerHTML = `<div class="c-filtered-list-items-no-results col-span-3">${this.globals?.labelNoResults ?? 'No results found'}</div>`
      console.warn('Failed to render blog type list:', error)
    } finally {
      await Sleep()
      this.content.style.height = ''
    }
  }

  appendToContent(slides, title, url, globals) {
    if (!slides.length) return

    const carousel = BlogPostCarousel({
      slides: slides,
      title: title,
      url: url,
      globals,
    })

    const node = document.createElement('div')
    node.innerHTML = carousel
    this.content.append(node)
  }

  filterData(data, filterProp = 'categories') {
    return data.filter((entry) => {
      if (this.activeFilters.length === 0) {
        return true
      } else {
        return this.activeFilters.some((filter) => {
          const propSlugs = entry[filterProp].map((prop) => prop.slug)
          return propSlugs.includes(filter)
        })
      }
    })
  }
}
